export const GET_CUSTOMER_ID = 'getCustomerId';
export const GET_CUSTOMER_NAME = 'GET_CUSTOMER_NAME';
export const GET_CUSTOMER_TYPE_ID = 'getCustomerTypeId';
export const GET_ROLE_ID = 'getRoleId';
export const GET_USER_ID = 'getUserId';
export const HAS_PRIVILEGES_OVER_TICKETS = 'hasPrivilegesOverTickets';
export const HAS_PRIVILEGES_OVER_FEEDBACKS = 'hasPrivilegesOverFeedbacks';
export const HAS_PRIVILEGES_OVER_PDT = 'hasPrivilegesOverPDT';
export const HAS_PRIVILEGES_OVER_REPORTS = 'hasPrivilegesOverReports';
export const HAS_PRIVILEGES_OVER_HEALTH_REPORTS = 'hasPrivilegesOverHealthReports';
export const HAS_PRIVILEGES_OVER_FINANCES = 'hasPrivilegesOverFinances';
export const HAS_PRIVILEGES_OVER_DIRECTORY_GROUPS = 'hasPrivilegesOverActiveDirectoryGroups';
export const HAS_PRIVILEGES_OVER_CUSTOMERS = 'hasPrivilegesOverCustomers';
export const HAS_PRIVILEGES_OVER_EQUIPMENTS = 'hasPrivilegesOverEquipments';
export const HAS_PRIVILEGES_OVER_CONTACTS = 'hasPrivilegesOverContacts';
export const IS_EMPLOYEE = 'isEmployee';
export const HAS_PRIVILEGES_OF_READ_TICKETS = 'HAS_PRIVILEGES_OF_READ_TICKETS';
export const GET_USER_CONTACT = 'GET_USER_CONTACT';
export const HAS_PRIVILEGES_OVER_EQUIPMENT_MOVEMENT = 'HAS_PRIVILEGES_OVER_EQUIPMENT_MOVEMENT';
export const HAS_PRIVILEGES_OF_CREATE_PDT = 'HAS_PRIVILEGES_OF_CREATE_PDT';
export const IS_CONTACT_ADMINISTRATOR = 'IS_CONTACT_ADMINISTRATOR';

export enum UserGetters {
    GET_USER_ROLE = 'GET_USER_ROLE',
    GET_CURRENT_USER = 'GET_CURRENT_USER',
    GET_CUSTOMER_OPTIONS = 'GET_CUSTOMER_OPTIONS',
    HAS_PRIVILEGES_OVER_TICKETS = 'hasPrivilegesOverTickets',
    HAS_PRIVILEGES_OVER_FEEDBACKS = 'hasPrivilegesOverFeedbacks',
    IS_CONTACT_ADMINISTRATOR = 'IS_CONTACT_ADMINISTRATOR',
    GET_CUSTOMER_ID = 'getCustomerId',
}
